var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import classNames from 'classnames';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Signals from '../../../../signals/Signals';
/**
 *
 */
var AlertModal = /** @class */ (function (_super) {
    __extends(AlertModal, _super);
    /**
     *
     * @param props
     */
    function AlertModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            show: props.show
        };
        _this.confirm = _this.confirm.bind(_this);
        _this.show = _this.show.bind(_this);
        Signals.ShowAlertModal.add(_this.show);
        return _this;
    }
    /**
     *
     */
    AlertModal.prototype.componentWillUnmount = function () {
        Signals.ShowAlertModal.remove(this.show);
    };
    /**
     *
     * @return {*}
     */
    AlertModal.prototype.render = function () {
        var classes = classNames({
            'alert-modal': true,
            'alert-modal--showing': this.state.show
        });
        { /* Confirm Modal */ }
        return (React.createElement(Modal, { className: classes, isOpen: this.state.show },
            React.createElement(ModalHeader, { toggle: this.confirm }, this.state.title),
            React.createElement(ModalBody, null,
                React.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.body } })),
            React.createElement(ModalFooter, null,
                React.createElement("button", { className: "btn btn-primary", onClick: this.confirm }, this.state.confirmText))));
    };
    /**
     *
     */
    AlertModal.prototype.confirm = function () {
        this.setState({ show: false });
        if (this.state.onConfirm) {
            this.state.onConfirm();
        }
    };
    /**
     *
     * @param title
     * @param body
     * @param confirmText
     * @param onConfirm
     */
    AlertModal.prototype.show = function (title, body, confirmText, onConfirm) {
        if (confirmText === void 0) { confirmText = 'Ok'; }
        if (onConfirm === void 0) { onConfirm = null; }
        this.setState({ show: true, title: title, body: body, confirmText: confirmText, onConfirm: onConfirm });
    };
    return AlertModal;
}(React.Component));
export default AlertModal;
